$(document).ready(function($) {

	$(".gravity-form input:not([type='radio']):not([type='checkbox']):not([type='submit']):not([type='button']):not([type='image']):not([type='file']):not([type='hidden']),textarea").on('focusin', function(event) {
		$(this).closest('.gfield').addClass('active');
	});
	
	$(".gravity-form input:not([type='radio']):not([type='checkbox']):not([type='submit']):not([type='button']):not([type='image']):not([type='file']):not([type='hidden']),textarea").on('focusout', function(event) {
		if ($(this).val().length == 0) {
			$(this).closest('.gfield').removeClass('active');
		}
	});

	$(".gravity-form input:not([type='radio']):not([type='checkbox']):not([type='submit']):not([type='button']):not([type='image']):not([type='file']):not([type='hidden']),textarea").each(function(index, el) 
		{
			if ($(this).val().length > 0) {
				$(this).closest('.gfield').addClass('active');
			}
	});
});